<template>
	<div>
		<new-page-gen :options="options" />
	</div>
</template>

<script>
import NewPageGen from './NewPageGen.vue'

const config = {
	options: {
		resource: 'user-groups',
		schemaModifier: async data => {
			data.autocompleteFields = [
				{
					name: 'users',
					resource: 'users',
					query: 'id',
					display: 'id'
				}
			]
			return data
		}
	}
}

export default {
	name: 'UserGroupsNew',
	components: { NewPageGen },
	data: () => config
}
</script>
